// assets/tb-card-product-media-slider.js
(function () {
  "use strict";

  if (window.TBCardProductMediaSlider && window.TBCardProductMediaSlider.__bound) {
    window.TBCardProductMediaSlider.initAll();
    return;
  }

  function hardStop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
  }

  function pointInRect(x, y, rect) {
    if (!rect) return false;
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (!cs) return false;
    return cs.display !== "none" && cs.visibility !== "hidden" && cs.opacity !== "0";
  }

  function setVideoLabel(root, text) {
    var label = root.querySelector("[data-tb-video-label]");
    if (label) label.textContent = text;

    var icon = root.querySelector(".tb-card-media-slider__video-icon");
    if (icon) icon.textContent = (text === "PAUSE") ? "⏸" : "▶";
  }

  function getTotal(root) {
    var total = parseInt(root.getAttribute("data-total-slides") || "1", 10);
    if (!total || total < 1) total = 1;
    return total;
  }

  function pauseAnyVideo(root) {
    var v = root.querySelector(".tb-card-media-slider__slide.is-active video");
    if (v && typeof v.pause === "function") {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }

    var ifr = root.querySelector(".tb-card-media-slider__slide.is-active iframe");
    if (ifr) {
      var normal = ifr.getAttribute("data-tb-src");
      if (normal) ifr.src = normal;
      root.__tbExternalPlaying = false;
    }

    setVideoLabel(root, "VIDEO");
  }

  function playActiveVideoIfAny(root) {
    var active = root.querySelector(".tb-card-media-slider__slide.is-active");
    if (!active) return;

    var v = active.querySelector("video");
    if (v && typeof v.play === "function") {
      v.muted = true;
      var p = v.play();
      setVideoLabel(root, "PAUSE");
      v.onended = function () { setVideoLabel(root, "VIDEO"); };
      if (p && typeof p.catch === "function") {
        p.catch(function () { setVideoLabel(root, "VIDEO"); });
      }
      return;
    }

    var iframe = active.querySelector("iframe");
    if (iframe) {
      var autoSrc = iframe.getAttribute("data-tb-src-autoplay");
      if (autoSrc) iframe.src = autoSrc;
      root.__tbExternalPlaying = true;
      setVideoLabel(root, "PAUSE");
    }
  }

  function setActive(root, nextIndex) {
    var total = getTotal(root);

    if (nextIndex < 1) nextIndex = total;
    if (nextIndex > total) nextIndex = 1;

    pauseAnyVideo(root);

    var slides = root.querySelectorAll(".tb-card-media-slider__slide");
    slides.forEach(function (s) {
      var idx = parseInt(s.getAttribute("data-index") || "0", 10);
      var isActive = idx === nextIndex;
      s.classList.toggle("is-active", isActive);
      s.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    var currentEl = root.querySelector("[data-tb-current]");
    if (currentEl) currentEl.textContent = String(nextIndex);

    root.__tbCurrent = nextIndex;

    var active = root.querySelector(".tb-card-media-slider__slide.is-active");
    if (active && active.getAttribute("data-type") === "video") {
      playActiveVideoIfAny(root);
    } else {
      setVideoLabel(root, "VIDEO");
    }
  }

  function toggleVideo(root, btnVideo) {
    var vidIndex = parseInt(btnVideo.getAttribute("data-video-index") || "0", 10);
    if (!vidIndex) return;

    var active = root.querySelector(".tb-card-media-slider__slide.is-active");
    var isVideoActive = active && active.getAttribute("data-type") === "video";

    if (!isVideoActive) {
      setActive(root, vidIndex);
      return;
    }

    var v = active.querySelector("video");
    if (v) {
      if (v.paused) playActiveVideoIfAny(root);
      else { v.pause(); setVideoLabel(root, "VIDEO"); }
      return;
    }

    var iframe = active.querySelector("iframe");
    if (iframe) {
      var normal = iframe.getAttribute("data-tb-src");
      var autoSrc = iframe.getAttribute("data-tb-src-autoplay");
      if (!normal || !autoSrc) return;

      if (root.__tbExternalPlaying) {
        iframe.src = normal;
        root.__tbExternalPlaying = false;
        setVideoLabel(root, "VIDEO");
      } else {
        iframe.src = autoSrc;
        root.__tbExternalPlaying = true;
        setVideoLabel(root, "PAUSE");
      }
    }
  }

  function initOne(root) {
    if (!root || root.__tbInit) return;
    root.__tbInit = true;

    root.__tbCurrent = 1;
    root.__tbExternalPlaying = false;

    var showSlider = root.getAttribute("data-show-slider") === "true";
    if (!showSlider) return;

    setActive(root, 1);
  }

  function initAll() {
    document.querySelectorAll("[data-tb-card-slider]").forEach(initOne);
  }

  // =========================================================
  // CRITICAL: Global CAPTURE click router with hit-test
  // If Dawn overlay steals the event target, we still detect
  // if the click coordinates are inside our buttons.
  // =========================================================
  document.addEventListener("click", function (e) {
    var x = e.clientX, y = e.clientY;

    // find nearest card wrapper then slider
    var card = e.target && e.target.closest ? e.target.closest(".card-wrapper.product-card-wrapper") : null;
    if (!card) return;

    var root = card.querySelector("[data-tb-card-slider]");
    if (!root) return;

    // ensure initialized
    initOne(root);

    var showSlider = root.getAttribute("data-show-slider") === "true";
    if (!showSlider) return;

    var btnPrev = root.querySelector("[data-tb-prev]");
    var btnNext = root.querySelector("[data-tb-next]");
    var btnVideo = root.querySelector("[data-tb-video-btn]");

    // If click point is inside any control rect -> intercept navigation
    if (btnPrev && isVisible(btnPrev) && pointInRect(x, y, btnPrev.getBoundingClientRect())) {
      hardStop(e);
      setActive(root, (root.__tbCurrent || 1) - 1);
      return;
    }

    if (btnNext && isVisible(btnNext) && pointInRect(x, y, btnNext.getBoundingClientRect())) {
      hardStop(e);
      setActive(root, (root.__tbCurrent || 1) + 1);
      return;
    }

    if (btnVideo && isVisible(btnVideo) && pointInRect(x, y, btnVideo.getBoundingClientRect())) {
      hardStop(e);
      toggleVideo(root, btnVideo);
      return;
    }
  }, true); // capture = true

  // Re-init for dynamic DOM updates (filters/sections)
  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scheduleInit();
        break;
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);

  window.TBCardProductMediaSlider = {
    __bound: true,
    initAll: initAll
  };
})();
